import React, { useRef, useState } from "react";
import styles from "../../assets/scss/pages.module.scss";
import placeholderImage from "../../assets/images/placeholder.png";
import uploadImage from "../../assets/images/upload.png";
import SearchIcon from "components/svgs/SearchIcon";
import DeleteIcon from "components/svgs/DeleteIcon";

const MyProfileAddArtworkPage = () => {
  const artworkRef = useRef(null);
  const [selectedTab, setSelectedTab] = useState("artwork");
  const [formData, setFormData] = useState({
    artworks: [],
  });

  const handleArtworksChange = (event) => {
    if (event.target.files.length > 0) {
      setFormData({
        ...formData,
        artworks: [...formData.artworks, event.target.files[0]],
      });
    }
  };

  const handlePortraitDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length > 0 && formData.artworks.length < 4) {
      setFormData({
        ...formData,
        artworks: [...formData.artworks, droppedFiles[0]],
      });
    }
  };

  const handleArtworkDelete = (indexToRemove) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      artworks: prevFormData.artworks.filter(
        (_, index) => index !== indexToRemove
      ),
    }));
  };

  return (
    <div className={styles.myProfileAddArtworkPageContainer}>
      <div className="container">
        <div className={styles.navContainer}>
          <ul className={styles.nav}>
            <li
              className={`${styles.navItem} ${
                selectedTab === "artwork" ? styles.selected : ""
              }`}
              onClick={() => setSelectedTab("artwork")}
            >
              <span className={styles.number}>1</span>
              <span className={styles.text}>Artwork</span>
            </li>
            <li
              className={`${styles.navItem} ${
                selectedTab === "techniques" ? styles.selected : ""
              }`}
              onClick={() => setSelectedTab("techniques")}
            >
              <span className={styles.number}>2</span>
              <span className={styles.text}>Techniques</span>
            </li>
            <li
              className={`${styles.navItem} ${
                selectedTab === "description" ? styles.selected : ""
              }`}
              onClick={() => setSelectedTab("description")}
            >
              <span className={styles.number}>3</span>
              <span className={styles.text}>Description</span>
            </li>
            <li
              className={`${styles.navItem} ${
                selectedTab === "price" ? styles.selected : ""
              }`}
              onClick={() => setSelectedTab("price")}
            >
              <span className={styles.number}>4</span>
              <span className={styles.text}>Price and Delivery</span>
            </li>
            <li
              className={`${styles.navItem} ${
                selectedTab === "publishing" ? styles.selected : ""
              }`}
              onClick={() => setSelectedTab("publishing")}
            >
              <span className={styles.number}>5</span>
              <span className={styles.text}>Publishing</span>
            </li>
          </ul>
        </div>
        <div className={styles.tabContent}>
          {selectedTab === "artwork" ? (
            <div className={styles.artworkTab}>
              <h2>Add Picture</h2>
              <div className={styles.picturesContainer}>
                {formData.artworks.map((artwork, index) => {
                  return (
                    <div
                      key={index + artwork.name}
                      className={styles.selectedArtworkContainer}
                    >
                      <div className={styles.selectedArtwork}>
                        <img
                          src={URL.createObjectURL(artwork)}
                          alt={artwork.name}
                        />
                      </div>
                      <div className={styles.imageActions}>
                        <div
                          className={styles.cropImage}
                          // onClick={() => {
                          //   setShowPortraitCropPopup(true);
                          //   setSelectedCropImage({
                          //     file: document,
                          //     type: "document",
                          //     index,
                          //   });
                          // }}
                        >
                          <span>Crop</span>
                          <SearchIcon />
                        </div>
                        <div
                          className={styles.deleteImage}
                          onClick={() => handleArtworkDelete(index)}
                        >
                          <span>Delete</span>
                          <DeleteIcon />
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div
                  className={styles.uploadFileContainer}
                  onDrop={handlePortraitDrop}
                  onDragOver={(event) => event.preventDefault()}
                  onClick={() =>
                    formData.artworks.length < 4 && artworkRef.current?.click()
                  }
                >
                  <img
                    className={styles.placeholderImage}
                    src={placeholderImage}
                    alt="placeholder"
                  />
                  <img
                    className={styles.uploadImage}
                    src={uploadImage}
                    alt="placeholder"
                  />
                  <div className={styles.uploadFileText}>Upload a file</div>
                  <div className={styles.dragDropText}>
                    Drag and drop files here
                  </div>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    accept="image/*"
                    ref={artworkRef}
                    onChange={handleArtworksChange}
                  />
                </div>
              </div>
            </div>
          ) : selectedTab === "techniques" ? (
            <div className={styles.techniquesTab}>Techniques tab content</div>
          ) : selectedTab === "description" ? (
            <div className={styles.descriptionTab}>Description tab content</div>
          ) : selectedTab === "price" ? (
            <div className={styles.priceTab}>
              Price and Delivery tab content
            </div>
          ) : selectedTab === "publishing" ? (
            <div className={styles.publishingTab}>Publishing tab content</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MyProfileAddArtworkPage;
